/**
 *   Created by Arif Topcu in 2018
 */
import React, {useCallback} from 'react';
import Input from "@ls/react-input";
import {selectSelectedMinBmkWeight} from 'state/selections/selectors';
import SelectionState from 'state/selections/SelectionState';
import {setMinBenchWeight} from 'state/selections/actions';
import {useDispatch, useSelector} from 'react-redux';

const MinBenchWeightInput = (props) => {
  const dispatch = useDispatch();
  const value = useSelector(selectSelectedMinBmkWeight(SelectionState.UNCOMMITTED));
  const onChange = useCallback((val) => {
    dispatch(setMinBenchWeight(val?.length ? Number(val) : null));
  }, [dispatch]);

  return (
    <Input
      label="Min. Benchmark Weight (%):"
      placeholder="Default"
      value={value ?? ''}
      size="S"
      onChange={onChange}
      variation={2}
      type="number"
      min={0}
      max={100}
      step={0.01}
    />
  );
};

export default MinBenchWeightInput;
